import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: "input-legend",
  templateUrl: "input-legend.html",
})
export class InputLegend implements OnInit {
  @Input() text;
  translatedText: string;
  textHasSpaces: boolean = false;
  constructor(private translatePipe: TranslateService) {}

  ngOnInit(): void {
    this.translatedText = this.translatePipe.instant(this.text);
    if (/\s/.test(this.translatedText)) {
      this.textHasSpaces = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/input-legend/input-legend.ts